import React, { useEffect, useRef } from "react";
import { StyledATag, styles } from "../styles";
import PropTypes from 'prop-types';

const BottomNavigation = ({isActiveBottomNav,handleBottomNavigationClick}) => {
    const navRef = useRef({});
    useEffect(() => {
        const activeTab = navRef.current[isActiveBottomNav]
        const navContainer = document.querySelector('.bottomNavContainer');
    
        if(activeTab && navContainer) {
            const tabPosition = activeTab.offsetLeft - navContainer.offsetWidth / 2 + activeTab.offsetWidth / 2;
            navContainer.scrollTo({left: tabPosition, behavior: 'smooth'});
        }
        }, [isActiveBottomNav]);
        const handleATagClick = (e) => {
            e.preventDefault();
        }
    return(
        <div className="bottomNavContainer" style={styles.bottomNavBar}>
            {['Overview','Getting Started','Authorization','Patient Access','Provider Directory','Privacy And Terms of Service','Contact Us'].map((id) => (
                <button key={id} style={styles.bottomNavBarItem(isActiveBottomNav === id)} onClick={() => handleBottomNavigationClick(id)} ref={(el)=>navRef.current[id] = el}>
                   <StyledATag href={id} style= {{textDecoration:'none'}} onClick={handleATagClick}> {id} </StyledATag> 
                </button>
            ))}
        </div>
    )
}

BottomNavigation.propTypes = {
    isActiveBottomNav: PropTypes.string.isRequired,
    handleBottomNavigationClick: PropTypes.func.isRequired,
}

export default BottomNavigation;